import { PropsWithChildren } from "react";
import { useAuth } from "../../hooks/useAuth";
import { UserRole } from "../../utils/types";

export const AdminScope = ({ children }: PropsWithChildren) => {
  const { roles } = useAuth();

  const isAdmin = Array.isArray(roles)
    ? roles.some((role) => role === "ADMIN")
    : (roles as UserRole | null) === "ADMIN";
  if (!isAdmin) {
    return null;
  }

  return <>{children}</>;
};
